import NavigationComponent from 'components/navigationComponents/NavigationComponent'
import FooterComponent from 'components/footerComponents/FooterComponent'
import SettingsComponent from 'components/coursesDashboard/SettingsComponent'

function OrderSettings() {
  return (
    <div>
        <NavigationComponent/>
        <SettingsComponent/>
        <FooterComponent/>
    </div>
  )
}

export default OrderSettings